import { NgModule } from '@angular/core';
import { LogRoutingModule } from './log-routing.module';
import { LogOplogComponent } from './oplog/oplog.component';
import { LogOplogEditComponent } from './oplog/edit/edit.component';
import { LogOplogViewComponent } from './oplog/view/view.component';
import {SharedModule} from "@dragshalom/shareddemo";

const COMPONENTS = [
  LogOplogComponent];
const COMPONENTS_NOROUNT = [
  LogOplogEditComponent,
  LogOplogViewComponent];

@NgModule({
  imports: [
    SharedModule,
    LogRoutingModule
  ],
  declarations: [
    ...COMPONENTS,
    ...COMPONENTS_NOROUNT
  ],
  entryComponents: COMPONENTS_NOROUNT
})
export class LogModule { }
